module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-d4582fc3.png";